<template>
  <div class="fab-group">
    <a :href="email">
      <div class="fab-item bg-warning text-white">
        <i class="fas fa-envelope fa-2x" />
      </div>
    </a>
   
    <a :href="whatsapp">
      <div class="fab-item bg-success text-white">
        <i class="fab fa-whatsapp fa-2x" />
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email:'mailto:sales@zonasea.com?cc=muara@zonasea.com&subject=Tertarik Dengan Aplikasi Zonasea&body=Halo,%0A%0ASaya tertarik menggunakan aplikasi Zonasea. Tolong hubungi saya kembali ya.%0A%0ATerimakasih.',
      whatsapp: 'https://api.whatsapp.com/send?phone=+6285286653138&text=Halo, saya tertarik untuk menggunakan aplikasi Zonasea, tolong hubungi saya kembali ya. Terima kasih'
    }
  },
}
</script>

<style lang="scss" scoped>
  .fab-group {
    position: fixed;
    bottom: 25px;
    right: 25px;
    width: auto;
    max-width: 150px;
    height: 50px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-around;

    a {
      color: $white-color;
      text-decoration: none;
    }

    .fab-item {
      margin: 5px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      box-shadow: 1px 2px 2px black;
    }

    .fab-item:hover {
      cursor: pointer;
      margin: 5px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      box-shadow: 0 0 10px 2px black;
    }
  }

</style>